import { call, put, takeEvery } from 'redux-saga/effects';
import download from 'downloadjs';
import callApi from 'utils/callApi';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { updateOrderLines } from 'redux/modules/ordersLines';
import { addPatientResource } from 'redux/modules/patients';

// Actions
export const CREATE_ORDER_LINE_DOCUMENT = 'CREATE_ORDER_LINE_DOCUMENT';
export const CREATE_ORDER_LINE_DOCUMENT_SUCCESS = 'CREATE_ORDER_LINE_DOCUMENT_SUCCESS';
export const CREATE_ORDER_LINE_DOCUMENT_FAIL = 'CREATE_ORDER_LINE_DOCUMENT_FAIL';
export const DELETE_ORDER_LINE_DOCUMENT = 'DELETE_ORDER_LINE_DOCUMENT';
export const DELETE_ORDER_LINE_DOCUMENT_SUCCESS = 'DELETE_ORDER_LINE_DOCUMENT_SUCCESS';
export const DELETE_ORDER_LINE_DOCUMENT_FAIL = 'DELETE_ORDER_LINE_DOCUMENT_FAIL';
export const DOWNLOAD_ORDER_LINE_DOCUMENT = 'DOWNLOAD_ORDER_LINE_DOCUMENT';
export const DOWNLOAD_ORDER_LINE_DOCUMENT_SUCCESS = 'DOWNLOAD_ORDER_LINE_DOCUMENT_SUCCESS';
export const DOWNLOAD_ORDER_LINE_DOCUMENT_FAIL = 'DOWNLOAD_ORDER_LINE_DOCUMENT_FAIL';

// Reducer
export default function ordersLinesDocumentsReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type, payload } = action;
  switch (type) {
    case DELETE_ORDER_LINE_DOCUMENT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        const newOrderLine = dataItem['Order Line'].map((orderLineItem) => {
          if (orderLineItem.CMN
            && orderLineItem.CMN
            && orderLineItem.CMN.ID === payload.ID) {
            return {
              ...orderLineItem,
              CMN: {},
            };
          }
          return orderLineItem;
        });

        return {
          ...dataItem,
          'Order Line': newOrderLine,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function createOrderLineDocument(payload) {
  return { type: CREATE_ORDER_LINE_DOCUMENT, payload };
}

export function createOrderLineDocumentSuccess(payload) {
  return { type: CREATE_ORDER_LINE_DOCUMENT_SUCCESS, payload };
}

export function createOrderLineDocumentFail(payload) {
  return { type: CREATE_ORDER_LINE_DOCUMENT_FAIL, payload };
}

export function deleteOrderLineDocument(payload) {
  return { type: DELETE_ORDER_LINE_DOCUMENT, payload };
}

export function deleteOrderLineDocumentSuccess(payload) {
  return { type: DELETE_ORDER_LINE_DOCUMENT_SUCCESS, payload };
}

export function deleteOrderLineDocumentFail(payload) {
  return { type: DELETE_ORDER_LINE_DOCUMENT_FAIL, payload };
}

export function downloadOrderLineDocument(payload) {
  return { type: DOWNLOAD_ORDER_LINE_DOCUMENT, payload };
}

export function downloadOrderLineDocumentSuccess(payload) {
  return { type: DOWNLOAD_ORDER_LINE_DOCUMENT_SUCCESS, payload };
}

export function downloadOrderLineDocumentFail(payload) {
  return { type: DOWNLOAD_ORDER_LINE_DOCUMENT_FAIL, payload };
}

// Requests
export function requestCreateOrderLineDocument(payload) {
  return callApi('workflow/cmn_document/', 'POST', payload, false);
}

export function requestDeleteOrderLineDocument(payload) {
  return callApi(`workflow/cmn_document/?id=${payload}`, 'DELETE');
}

export function requestDownloadOrderLineDocument({ href }) {
  return download(href);
}

// Sagas
function* createOrderLineDocumentSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const formData = new FormData();
    formData.append('object_id', values.ID);
    if (values.Name) {
      formData.append('file', values.Document, values.Name);
    } else {
      formData.append('file', values.Document);
    }
    const res = yield call(requestCreateOrderLineDocument, formData);
    yield put(updateOrderLines({
      values: [{
        ID: values.ID,
        orderID: values.orderID,
        'CMN ID': res.data.ID,
        'CMN/AMB': values['CMN/AMB'],
      }],
      showNotification: false,
    }));
    yield put(addPatientResource({
      'Record Number': values['Record Number'],
      'Document ID': [res.data.ID],
    }));
    yield put(createOrderLineDocumentSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createOrderLineDocumentFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deleteOrderLineDocumentSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestDeleteOrderLineDocument, values.ID);
    yield put(deleteOrderLineDocumentSuccess(values));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(values);
    }
  } catch (err) {
    yield put(deleteOrderLineDocumentFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* downloadOrderLineDocumentSaga(action) {
  try {
    yield call(requestDownloadOrderLineDocument, action.payload);
    yield put(downloadOrderLineDocumentSuccess());
  } catch (err) {
    yield put(downloadOrderLineDocumentFail());
  }
}

export function* ordersLinesDocumentsSaga() {
  yield takeEvery(CREATE_ORDER_LINE_DOCUMENT, createOrderLineDocumentSaga);
  yield takeEvery(DELETE_ORDER_LINE_DOCUMENT, deleteOrderLineDocumentSaga);
  yield takeEvery(DOWNLOAD_ORDER_LINE_DOCUMENT, downloadOrderLineDocumentSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/ordersLinesDocuments.js